class ProductOffer extends HTMLElement {
  constructor() {
    super();

    this.buttonElement = this.querySelector('[data-offer-submit]');
    this.isLoading = false;
  }

  connectedCallback() {
    if (!this.buttonElement) return;

    this.buttonElement.addEventListener('click', this.addProductToCart.bind(this));
  }

  get formElement() {
    return document.querySelector(this.dataset.offerForm);
  }

  get selectedVariantId() {
    const variantInputElement = this.formElement && this.formElement.querySelector('[name="id"]');

    return (variantInputElement && variantInputElement.value) || this.dataset.offerVariantId;
  }

  get quantityToAdd() {
    return parseInt(this.dataset.offerQuantity, 10) || 1;
  }

  openCartDrawer() {
    const themeGlobal = window.T4SThemeSP;
    const jQueryGlobal = window.jQuery_T4NT;

    if (!themeGlobal || !themeGlobal.Drawer || !jQueryGlobal) return;

    const cartDrawerElement = jQueryGlobal('#t4s-mini_cart');

    if (!cartDrawerElement.length || cartDrawerElement.attr('aria-hidden') === 'false') return;

    if (!themeGlobal.cartTabActive) {
      jQueryGlobal('[data-is-tab-cart]').trigger('click');
    }

    themeGlobal.Drawer.opend(cartDrawerElement);
  }

  setLoadingState(isLoading) {
    this.isLoading = isLoading;
    this.buttonElement.classList.toggle('product-offer__button--loading', isLoading);
    this.buttonElement.disabled = isLoading;
    this.buttonElement.setAttribute('aria-busy', isLoading);
  }

  async addProductToCart() {
    if (this.isLoading) return;

    const variantId = this.selectedVariantId;

    if (!variantId) return;

    this.setLoadingState(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: this.quantityToAdd
            }
          ],
          sections: 'cart_data,mini_cart',
          sections_url: window.location.pathname
        })
      });

      const cartData = await response.json();

      if (cartData.status) {
        document.dispatchEvent(new CustomEvent('product-offer:error', { detail: { error: cartData } }));
        return;
      }

      if (window.T4SThemeSP && window.T4SThemeSP.Cart) {
        window.T4SThemeSP.Cart.renderContents(cartData.sections, true);
      }

      this.openCartDrawer();

      document.dispatchEvent(new CustomEvent('product-offer:added', { detail: { cart: cartData } }));
    } catch (error) {
      document.dispatchEvent(new CustomEvent('product-offer:error', { detail: { error: error } }));
    } finally {
      this.setLoadingState(false);
    }
  }
}

customElements.define('product-offer', ProductOffer);
